import {useEffect, useRef, useState} from "react";
import ModalFactory from "./ModalFactory";
import {appArray} from "../../App";


function GeneralModal(props: any) : JSX.Element{
    const icon = appArray.find((app) => app.id === props.id)?.icon;
    const windowTitle = appArray.find((app) => app.id === props.id)?.name;

    let isMaximised = false;
    let restoreSize = {width: 0, height: 0, top: 0, left: 0};

    // check if props has initial width, height, and position
    let initialWidth = 350;
    let initialHeight = 420;
    let initialTop = 50;
    let initialLeft = 50;
    if (props.width) {
        initialWidth = props.width;
        initialHeight = props.height;
        initialTop = props.top;
        initialLeft = props.left;
    }

    let titleBarRef = useRef<HTMLDivElement>(null);
    let windowRef = useRef<HTMLDivElement>(null);
    let resizeRef = useRef<HTMLDivElement>(null);

    // set initial state
    windowRef.current?.style.setProperty("width", initialWidth + "px");
    windowRef.current?.style.setProperty("height", initialHeight + "px");
    windowRef.current?.style.setProperty("top", initialTop + "px");
    windowRef.current?.style.setProperty("left", initialLeft + "px");

    // Make the DIV element draggable from the title bar
    useEffect(() => {
        if (titleBarRef.current && windowRef.current) {
            titleBarRef.current.onmousedown = dragMouseDown;
            titleBarRef.current.ontouchstart = dragTouchDown;
        }

        function dragMouseDown(e: MouseEvent) {
            e = e || window.event;
            e.preventDefault();

/*          NOTE: Invalid hook call. Hooks can only be called inside of the body of a function component.
            // if window is not on top, bring it to the front
            let modal = ModalFactory.getModal(props.id);
            if (!modal.isOnTop) {
                modal.setOnTop(true);
            }*/

            // get the mouse cursor position at startup:
            let pos1 = e.clientX;
            let pos2 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;

            function elementDrag(e: MouseEvent) {
                e = e || window.event;
                e.preventDefault();
                // calculate the new cursor position:
                let pos3 = pos1 - e.clientX;
                let pos4 = pos2 - e.clientY;
                pos1 = e.clientX;
                pos2 = e.clientY;
                // set the element's new position:
                if (windowRef.current) {
                    windowRef.current.style.top = (windowRef.current.offsetTop - pos4) + "px";
                    windowRef.current.style.left = (windowRef.current.offsetLeft - pos3) + "px";
                }
            }

            function closeDragElement() {
                // stop moving when mouse button is released:
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }

        function dragTouchDown(e: TouchEvent) {
            e = e || window.event;
            // get the mouse cursor position at startup:
            let pos1 = e.touches[0].clientX;
            let pos2 = e.touches[0].clientY;
            document.ontouchend = closeDragElement;
            // call a function whenever the cursor moves:
            document.ontouchmove = elementDrag;


            function elementDrag(e: TouchEvent) {
                // drag window with touchevent (touchscreen) instead of mouse event (mouse)
                e = e || window.event;
                e.preventDefault();
                // calculate the new cursor position:
                let pos3 = pos1 - e.touches[0].clientX;
                let pos4 = pos2 - e.touches[0].clientY;
                pos1 = e.touches[0].clientX;
                pos2 = e.touches[0].clientY;
                // set the element's new position:
                if (windowRef.current) {
                    windowRef.current.style.top = (windowRef.current.offsetTop - pos4) + "px";
                    windowRef.current.style.left = (windowRef.current.offsetLeft - pos3) + "px";
                }
            }

            function closeDragElement() {
                // stop moving when touch is released:
                document.ontouchend = null;
                document.ontouchmove = null;
            }
        }
    });

    function bringToFront() {
        // bring window to front
        let modal = ModalFactory.getModal(props.id);
        if (!modal.isOnTop) {
            modal.setOnTop(true);
        }
    }

    function minimize() {
        alert("minimize window")
    }

    // Toggle maximize and restore window
    function maximize() {
        // Temporarily add transition to window
        windowRef.current?.style.setProperty("transition", "all 0.2s ease-in-out");

        isMaximised = !isMaximised;
        if (isMaximised) {
            // save current size and position
            restoreSize = {
                width: windowRef.current?.offsetWidth || 0,
                height: windowRef.current?.offsetHeight || 0,
                top: windowRef.current?.offsetTop || 0,
                left: windowRef.current?.offsetLeft || 0
            }

            // set window to full screen
            windowRef.current?.style.setProperty("width", "99vw");
            windowRef.current?.style.setProperty("height", "calc(100vh - 50px)");
            windowRef.current?.style.setProperty("top", "0.3vh");
            windowRef.current?.style.setProperty("left", "0.5vw");
        } else {
            // restore window size and position
            windowRef.current?.style.setProperty("width", restoreSize.width + "px");
            windowRef.current?.style.setProperty("height", restoreSize.height + "px");
            windowRef.current?.style.setProperty("top", restoreSize.top + "px");
            windowRef.current?.style.setProperty("left", restoreSize.left + "px");
        }
        // remove temporary transition
        setTimeout(() => {
            windowRef.current?.style.setProperty("transition", "none");
        }, 200);

    }


    function closeWindow() {
        ModalFactory.closeModal(props.id);
    }

    return (
        <div className="window" style={modalStyle.window} ref={windowRef}>
            <div className="title-bar" ref={titleBarRef} style={modalStyle.titleBarContainer}>
                <div className="title-bar-text" style={modalStyle.titleBar}>
                    <img src={icon} style={{height: '20px', marginRight: '5px'}} alt='App icon'/>
                    {windowTitle}
                </div>
                <div className="title-bar-controls">
                    <button disabled={false} onClick={() => bringToFront()} aria-label="Minimize"></button>
                    <button onClick={() => maximize()} aria-label="Maximize"></button>
                    <button onClick={() => closeWindow()} aria-label="Close"></button>
                </div>
            </div>
            <div className="window-body" style={modalStyle.windowBody}>
                {props.children}
            </div>
            {/* bottom right of window create draggable area for resize */}
            <div
                className="resize-area"
                ref={resizeRef}
                style={{position: 'absolute', bottom: '0', right: '0', width: '20px', height: '20px',
                    cursor: 'se-resize'}}>

            </div>
        </div>
    )
}

const modalStyle = {
    window: {
        position: 'absolute' as 'absolute',
        minHeight: '200px',
        minWidth: '200px',

        resize: 'both' as 'both',
        overflow: 'hidden' as 'hidden',
    },
    titleBar: {
        display: 'flex',
        flexDirection: 'row' as 'row',
        alignItems: 'center',
        fontSize: '1.1em',
    },
    windowBody: {
        padding: '5px',
        overflow: 'auto' as 'auto',
        height: '100%',
    },
    titleBarContainer: {
    }
};

export default GeneralModal
